import { render, staticRenderFns } from "./StudentContractsHistory.vue?vue&type=template&id=26dce2ba&"
import script from "./StudentContractsHistory.vue?vue&type=script&lang=js&"
export * from "./StudentContractsHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports